// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const handTruck = defineModel({
  id: "hand-truck",
  batchId: "future",
  name: "Hand truck",
  tags: ["scenery","hand","truck","low-poly","age-of-mcp","future"],
  summary: "A two-wheel sack truck for shifting heavy sacks and crates.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.3,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.04, 0.62, 0.04), color: "#6e4f2e", position: [-0.13, 0.34, -0.06], rotation: [0.32, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.04, 0.62, 0.04), color: "#6e4f2e", position: [0.13, 0.34, -0.06], rotation: [0.32, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.3, 0.04, 0.04), color: "#8a6840", position: [0, 0.173908, -0.097748] },
      { geometry: new THREE.BoxGeometry(0.3, 0.04, 0.04), color: "#8a6840", position: [0, 0.373248, -0.163807] },
      { geometry: new THREE.BoxGeometry(0.3, 0.03, 0.18), color: "#8a6840", position: [0, 0.05, 0.12] },
      { geometry: new THREE.TorusGeometry(0.1, 0.03, 6, 12), color: "#4a4540", position: [-0.17, 0.1, -0.1], rotation: [0, 1.570796, 0] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.05, 8), color: "#563d22", position: [-0.17, 0.1, -0.1], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.TorusGeometry(0.1, 0.03, 6, 12), color: "#4a4540", position: [0.17, 0.1, -0.1], rotation: [0, 1.570796, 0] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.05, 8), color: "#563d22", position: [0.17, 0.1, -0.1], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.SphereGeometry(0.12, 6, 5), color: "#c7b27a", position: [0, 0.18, 0.08], scale: [1, 0.82, 1.08] },
      { geometry: new THREE.SphereGeometry(0.11, 6, 5), color: "#bba76e", position: [0.02, 0.36, 0], scale: [1, 0.82, 1.08] },
    ],
  animations: [],
});
